import {Label, SearchField} from "@heroui/react";

const SearchInput = ({ term, onChange }) => {
  return (
    <SearchField name="search" value= {term} onChange={onChange}>
      <Label>Search</Label>
      <SearchField.Group>
        <SearchField.SearchIcon />
        <SearchField.Input className="w-[180px]" placeholder="Search..." />
        <SearchField.ClearButton />
      </SearchField.Group>
    </SearchField>
  );
}

export default SearchInput